/** @jsxImportSource theme-ui */
import React, { ReactElement } from 'react';

import { Typography } from 'components/_common/Typography';

import { detailsSectionStyle } from './RiskOverviewStyles';

type RiskOverviewCardSectionTitleProps = {
  heading: string;
  title: string | ReactElement;
  subtitle: string | ReactElement;
  icon: any;
};

const RiskOverviewCardSectionTitle: React.FC<RiskOverviewCardSectionTitleProps> = ({
  heading,
  title,
  subtitle,
  icon,
}) => {
  return (
    <div sx={detailsSectionStyle}>
      <div>
        <Typography variant="h6" color="stone90">
          {heading}
        </Typography>
      </div>
      <div
        sx={{
          display: 'flex',
          alignItems: 'center',
          minWidth: ['36px', '244px'],
          maxWidth: ['36px', '244px'],
          ml: ['24px'],
          mr: ['6px', '18px'],
        }}
        className="fade-out-expanded"
      >
        <div sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{icon}</div>
        <div sx={{ display: ['none', 'flex'], flexDirection: 'column', ml: '10px' }}>
          <Typography variant="h6" color="stone90" marginBottom="4px">
            {title}
          </Typography>
          <Typography variant="caption" color="stone70" marginBottom="0">
            {subtitle}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default RiskOverviewCardSectionTitle;
